export default {
  title: 'Kategorie',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa kategorii',
      fieldRequired: true,
      maxLength: 500
    }
  }
};
